
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    whiteSpinner: { type: Boolean, default: false },
    size: { type: Number, default: 48 },
  },
});
